import "unfetch/polyfill";

function encodeQueryData(data) {
  const ret = [];
  for (const d in data) {
    ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(data[d]));
  }
  return "?" + ret.join("&");
}

/**
 * implode data to encoded URI component
 * @param data array or string data
 * @returns {string} encoded URI part
 */
function implodeData(data) {
  return encodeURIComponent(Array.isArray(data) ? data.join(",") : data);
}

/**
 * build query URL
 * @param apiUrl
 * @param apiKey
 * @param config settings of app and params defined by user
 * @param forCalendar
 * @param forCategoryCounter
 * @param getLocations evaluates if only locations should be loaded
 * @returns {string}
 */
function buildBasicQueryURL(
  apiUrl,
  apiKey,
  config,
  forCalendar,
  forCategoryCounter,
  getLocations
) {
  const query = {
    apiKey: apiKey
  };

  // features selected?
  if (config.feature_ids && config.feature_ids.length) {
    query.feature_ids = implodeData(config.feature_ids);
  }

  if (config.contain_by_feature_ids && config.contain_by_feature_ids.length) {
    query.contain_by_feature_ids = implodeData(config.contain_by_feature_ids);
  }

  // category selected?
  if (config.category_ids && config.category_ids.length) {
    query.category_ids = implodeData(config.category_ids);
  }

  if (config.contain_by_category_ids && config.contain_by_category_ids.length) {
    query.contain_by_category_ids = implodeData(config.contain_by_category_ids);
  }

  if (config.regionality) {
    query.regionality = config.regionality;
  }

  // active state
  if (config.active){
    query.active = true;
  }

  // hidden state
  if (!isNaN(config.hidden)) {
    const p = parseInt(config.hidden);
    if (p === 1 || p === 0) query.hidden = p;
  }

  // highlights only
  if (config.highlight){
    query.highlight = true;
  }

  // highlight_to_top selected?
  if (config.highlight_to_top) {
    query.highlight_to_top = 1;
  }

  // only ids or moments
  if (typeof config.ids === "object") {
    query.ids = config.ids.join(",");
  }
  if (typeof config.moment_ids === "object") {
    query.moment_ids = config.moment_ids.join(",");
  }

  // sort selected?
  if (config.sort) query.sort = config.sort;

  // paginate?
  if (config.page) query.page = config.page;

  // start/end
  if (config.start) query.start = config.start;
  if (config.end) query.end = config.end;

  // search?
  if (config.s) query.s = config.s;

  // location
  if (config.location) query.location = config.location;

  // limit
  if (config.limit) query.limit = config.limit;

  // offset
  if (config.offset) query.offset = config.offset;

  if (config.city) query.city = config.city;
  if (config.normalized_city) query.normalized_city = config.normalized_city;

  if (config.distinct) {
    query.distinct = true;
  }
  // one moment
  if (config.eventId) {
    if (config.populate) query.populate = true;
    if (config.momentId) query.populate_moment = config.momentId;

    return (
      apiUrl +
      "event/" +
      encodeURIComponent(config.eventId) +
      encodeQueryData(query)
    );
  }

  // direction selected?
  query.direction = config.direction === "desc" ? "desc" : "asc";

  return `${apiUrl}${getLocations ? "oploc/locationsForCalendar" : "event"}${
    forCalendar
      ? "/for_calendar"
      : forCategoryCounter
      ? "/count_categories"
      : ""
  }${encodeQueryData(query)}`;
}

export default function findEvents(
  apiUrl,
  apiKey,
  config,
  forCalendar = true,
  forCategoryCounter = false
) {
  return new Promise(function(resolve, reject) {
    fetch(
      buildBasicQueryURL(
        apiUrl,
        apiKey,
        config,
        forCalendar,
        forCategoryCounter
      )
    )
      .then(r => r.json())
      .then(data => {
        resolve(data);
      })
      .catch(reason => {
        reject(reason);
      });
  });
}

export function findLocations(apiUrl, apiKey, config) {
  return new Promise(function(resolve, reject) {
    fetch(buildBasicQueryURL(apiUrl, apiKey, config, false, false, true))
      .then(r => r.json())
      .then(data => {
        resolve(data);
      })
      .catch(reason => {
        reject(reason);
      });
  });
}
